<div class="sidebar fixed" [class.collapsed]="!expanded">
  <div class="menuList" [class.collapsed]="!expanded">
    <div class="menuHeader" [class.pt-3]="!expanded" style="cursor: pointer !important;">
      <ng-container *ngFor="let menu of menuList">
        <!-- Main Menu Item -->
        <div class="py-2 d-flex hoverMenulist" 
          [class.justify-content-center]="!expanded"
          [routerLink]="menu.route"
          routerLinkActive="active" #route="routerLinkActive"
          [class.active]="route.isActive"
          (click)="expanded ? activateRoute(menu) : null">
          <a class="menu-item d-flex align-items-center"></a>
          <img loading="lazy" class="menu-img px-2" [src]="menu.img" alt="" />
          <span class="menuTitle fw-semibold">{{ menu.title }}</span>
        </div>

        <!-- Sub Menu Items (only visible when expanded) -->
        <ng-container *ngIf="expanded && menu.subMenu?.length > 0 && menu.isActive">
          <div class="subMenu">
            <ng-container *ngFor="let subMenu of menu.subMenu">
              <div class="py-2 d-flex hoverMenulist" [routerLink]="'/reports/' + subMenu.route"
                routerLinkActive="active" #route="routerLinkActive" [class.active]="subMenu.isActive">
                <span class="menuTitle subMenuTitle">{{ subMenu.title }}</span>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>